import React from "react";
import PropTypes from "prop-types";
import { LogoImg, LogoWrapper } from "./style";
import logo from "../../assets/images/logo-tv.png"

const Logo = (props) => {

    return (
        <>
            <LogoWrapper {...props} to="/">
                <LogoImg src={logo} alt="Misli Tv"/>
            </LogoWrapper>
        </>
    );
};

Logo.propTypes = {
    left: PropTypes.bool,
    center: PropTypes.bool,
    loginPage: PropTypes.bool,
    matchDetail: PropTypes.bool
};

export default Logo;
